import { render, staticRenderFns } from "./contacts-list.vue?vue&type=template&id=2f454230"
import script from "./contacts-list.vue?vue&type=script&lang=js"
export * from "./contacts-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports